<div class="motor-add-dialog">
  <div class="motor-add-dialog-header mb-0">
    <div class="ui-g-12 flex-between-center">
      <div class="flex-start-center width-100p">
        <div class="icon">
          <img src="assets/connect-motor.svg" class="mr-1" />
        </div>

        <div class="pl-1 tire-description width-100p p-relative">
          <p class="m-0 font-18 font-700 font-black ">Connect vehicle to MOTOR</p>
        </div>

        <i class="far fa-times pointer dialog-close" (click)="handleCloseModal()"></i>
      </div>
    </div>
  </div>
  <div class="ui-g motor-body pt-0 pb-0 border-bottom-light font-16 p-4">
    <div>
      We found a match for this vehicle from MOTOR - <b>{{vehicle?.Year}} {{vehicle?.MakeName}}
        {{vehicle?.ModelName}} {{vehicle.SubModelName}}</b>.
    </div>

    <div>
      We recommend connecting to MOTOR so you can access this vehicle’s repair data.
    </div>
  </div>

  <div class="ui-g-12 flex-between-center dialog-footer part-footer p-0">
    <div class="motor-add-dialog-footer width-100p flex-end-center">
      <div>
        <button class="btn btn-border pointer btn-submit mr-1" (click)="handleCloseModal()">Cancel</button>
        <button class="btn btn-primary btn-submit btn-motor" (click)="handleSubmit()">
          <span [ngClass]="{ 'pr-2': isProcessing }">Connect to MOTOR</span>
          <i *ngIf="isProcessing" class="far fa-spinner rotate"></i>
        </button>
      </div>
    </div>
  </div>




</div>